// extracted by css-extract-rspack-plugin
export default {"wrapper":"dQ2YR","results":"tGelf","name":"Oagqp","description":"CONj5","clause":"CIeQS","structure":"tymUW","documentation":"kUQ_d"};